import {
  GET_ALL_CATEGORIES,
  ADD_CATEGORY,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  DELETE_ALL_CATEGORIES,
  GET_CATEGORY_BY_ID,
  GET_ALL_TAGS,
} from "../actions/types";

const initialState = {
  categories: [],
  selectedCategory: null,
  allTags: [],
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
      };
    case ADD_CATEGORY:
      return {
        ...state,
        categories: [...state.categories, action.payload],
      };
    case UPDATE_CATEGORY:
      return {
        ...state,
        categories: state.categories.map((category) =>
          category._id === action.payload._id ? action.payload : category
        ),
      };
    case DELETE_CATEGORY:
      return {
        ...state,
        categories: state.categories.filter((category) => category._id !== action.payload),
      };
    case DELETE_ALL_CATEGORIES:
      return {
        ...state,
        categories: [],
      };
    case GET_CATEGORY_BY_ID:
      return {
        ...state,
        selectedCategory: action.payload,
      };
    case GET_ALL_TAGS:
      return {
        ...state,
        allTags: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
